import { dynamic } from '#/utils/dynamic';

export const DynamicFeedbackModal = dynamic(
  () =>
    import('./FeedbackModal').then((m) => ({
      default: m.FeedbackModal,
    })),
  { strategy: 'always' },
);
